import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { IScoring } from "./asset"
import { SimpleRuleItem } from "../simple-rule"
import _ from 'lodash'

export class TextAnswerOptionsVM extends CommonOptionVM {
  default_value?: string
  min_length?: number
  max_length?: number
  manual_rating?: boolean
  required?: boolean
  secure?: boolean
  require_media?: boolean
  require_note?: boolean
  read_only?: boolean
  simple_rule?: SimpleRuleItem[];

  enable_score?: boolean;
  scoring?: IScoring;

  constructor(data?: Partial<TextAnswerOptionsVM>) {
    super(data)
    this.default_value = data?.default_value ?? undefined
    this.min_length = data?.min_length ?? undefined
    this.max_length = data?.max_length ?? undefined
    this.manual_rating = data?.manual_rating ?? undefined
    this.required = data?.required ?? undefined
    this.secure = data?.secure ?? undefined
    this.require_media = data?.require_media ?? undefined
    this.require_note = data?.require_note ?? undefined
    this.read_only = data?.read_only ?? undefined
    this.simple_rule = data?.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined

    this.enable_score = data?.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    if ((this.secure || this.read_only) && !this.default_value) {
      errors.push({ key: 'default_value', error_message: 'Default value is required when secure or read only is enabled' })
    }
    if (this.default_value && this.min_length && this.default_value.length < this.min_length) {
      errors.push({ key: 'default_value', error_message: 'Default value length must be greater than or equal to minimum length' })
    }

    if (this.default_value && this.max_length && this.default_value.length > this.max_length) {
      errors.push({ key: 'default_value', error_message: 'Default value length must be less than or equal to maximum length' })
    }

    if (this.min_length && this.max_length && this.min_length > this.max_length) {
      errors.push({ key: 'max_length', error_message: 'Maximum length must be greater than or equal to minimum length' })
    }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default TextAnswerOptionsVM